import React from "react";

import { useSortable } from "@dnd-kit/sortable";
import { IKanbanItemRecord } from "../../../lib/types";
import { CSS } from "@dnd-kit/utilities";

interface BoardItemProps {
    item: IKanbanItemRecord;
}

export default function BoardItem({ item }: BoardItemProps) {
    return (
        <div key={item.key} className="flex flex-col gap-2 rounded-md border bg-slate-50 px-4 py-4 dark:bg-slate-900">
            <h3 className="font-medium">{item.title}</h3>
            {item.tags.length > 0 && (
                <div className="flex items-center gap-1">
                    {item.tags.map((tag: string) => (
                        <div key={`${item.id}-tag-${tag}`} className="rounded-lg bg-blue-500 px-2 py-1 text-xs text-white">
                            {tag}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
